/*
 * @Author: liuyongjun
 * @Date: 2023-10-19 10:37:42
 * @LastEditors: liuyongjun
 * @LastEditTime: 2023-10-19 10:57:01
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: \ejx-web\src\directive\style\index.js
 */
import highlight from './highlight'

const install = function (Vue) {
  Vue.directive('highlight', highlight)
}

if (window.Vue) {
  window['highlight'] = highlight
  Vue.use(install); // eslint-disable-line
}

export default install
